__webpack_require__.p = "/SkinBook/";